import {
  Box,
  ListItemButton,
  Tooltip,
  Collapse,
  ClickAwayListener,
} from "@mui/material";
import {
  TrendingUp,
  Book,
  Group,
  CurrencyExchange,
  ExpandMore,
  ExpandLess,
  Paid,
  PriceChange,
  AccountBalance,
  Calculate,
  ContentPasteSearch,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch, RootState } from "shared/store/store";
import { Link, useLocation } from "react-router-dom";
import { RouterGuard } from "shared/components/RouteGuard";
import { accesRoles } from "../../models/roles";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import Images from "shared/assets/index";
import "./styles/_menuList.scss";
import { GET_CONTRACTS_NUMBER, GET_ELECTRONIC_DOCS } from "shared/api";
import {
  cleanLocalStorage,
  saveSearchHistoryElectronicDocument,
} from "shared/utils";
import React, { useEffect, useState } from "react";
import { ModalSeguimientoCuentas } from "pages/autorization-payments/components/ModalSeguimientoCuentas";

export const MenuList = () => {
  const dispatch = useDispatch<Dispatch>();
  const { selectedIndex, collapsed } = useSelector(
    (state: RootState) => state.menuDrawer,
  );
  const location = useLocation();

  const [financialSubmenuOpen, setFinancialSubmenuOpen] = useState(false);
  const [openSeguimientoCuentas, setOpenSeguimientoCuentas] = useState(false);

  useEffect(() => {
    if (location.pathname.startsWith("/autorizaciones") && !collapsed) {
      setFinancialSubmenuOpen(true);
    }
  }, [location.pathname, collapsed]);

  useEffect(() => {
    if (collapsed) {
      setFinancialSubmenuOpen(false);
    }
  }, [collapsed]);

  const handleChangeIndex = (index: number) =>
    dispatch.menuDrawer.changeSelectedIndex(index);

  const closeFinancialSubmenu = () => {
    setFinancialSubmenuOpen(false);
  };

  const toggleFinancialSubmenu = () => {
    if (collapsed) {
      dispatch.menuDrawer.setCollapsed(false);
      setFinancialSubmenuOpen(true);
    } else {
      const willOpen = !financialSubmenuOpen;
      setFinancialSubmenuOpen(willOpen);
    }
  };

  const handleDocumentActions = () => {
    dispatch.electronicDocuments.cleanState();
    dispatch.searcher.addText("");
    cleanLocalStorage("searchHistoryAutorizationPayments");
  };

  const handleElectronicDocumentsFetch = () => {
    const params = {
      states: "",
      origin: "MENU",
      documentType: "1",
      size: "50",
    };
    const url = `${GET_ELECTRONIC_DOCS}/page`;

    dispatch.electronicDocuments.getElectronicDocuments(params, url);
    saveSearchHistoryElectronicDocument({ params, url });
  };

  const handlePaymentsFetch = () => {
    const params = {
      states: "",
      isContract: false,
      isCertified: false,
      orderBy: 1,
    };
    const url = `${GET_ELECTRONIC_DOCS}/page_payments`;

    dispatch.electronicDocuments.getElectronicDocuments(params, url);
    //saveSearchHistoryElectronicDocument({ params, url });
  };

  const handleContractsFetch = () => {
    const params = {
      orderBy: "",
    };

    dispatch.electronicDocuments.getElectronicDocuments(
      params,
      GET_CONTRACTS_NUMBER,
    );
    //saveSearchHistoryElectronicDocument({ params, url });
  };

  const handleUsersProvidersFetch = () => {
    const params = {
      orderBy: "",
      page: 0,
      size: 50,
    };

    dispatch.electronicDocuments.getElectronicDocuments(
      params,
      `${process.env.REACT_APP_OAUTH}/users`,
    );
    //saveSearchHistoryElectronicDocument({ params, url });
  };

  const renderMenuItem = (content: React.ReactElement, tooltipText: string) => {
    if (collapsed) {
      return (
        <Tooltip
          title={tooltipText}
          placement="right"
          arrow
          sx={{
            "& .MuiTooltip-tooltip": {
              backgroundColor:
                "rgba(var(--general-color-r), var(--general-color-g), var(--general-color-b), 0.9)",
              color: "#fff",
              fontSize: "12px",
              padding: "8px 12px",
            },
          }}
        >
          {content}
        </Tooltip>
      );
    }
    return content;
  };

  return (
    <Box className="containerOptions">
      {renderMenuItem(
        <ListItemButton
          selected={selectedIndex === 0}
          data-testid="item-menu-home"
          onClick={() => {
            closeFinancialSubmenu();
            handleChangeIndex(0);
            dispatch.menuDrawer.setCollapsed(true);
          }}
          className="itemDrawer"
        >
          <Link to={"/"} aria-label="btn-home" data-testid="btn-menu-home">
            <img src={Images.iconoHome} alt="Home" />
            {!collapsed && <span>Inicio</span>}
          </Link>
        </ListItemButton>,
        "Inicio",
      )}

      {renderMenuItem(
        <ListItemButton
          selected={selectedIndex === 1}
          className="itemDrawer"
          onClick={() => {
            closeFinancialSubmenu();
            handleChangeIndex(1);
            handleDocumentActions();
            handleElectronicDocumentsFetch();
            dispatch.menuDrawer.setCollapsed(true);
          }}
          data-testid="item-menu-consultas"
        >
          <RouterGuard roles={accesRoles.reader} type="component">
            <Link
              to={"/consulta_documentos_electronicos"}
              aria-label="btn-consultas"
              data-testid="btn-menu-consultas"
            >
              <img src={Images.iconoFacturas} alt="Documento" />
              {!collapsed && <span>Documentos electrónicos</span>}
            </Link>
          </RouterGuard>
        </ListItemButton>,
        "Documentos electrónicos",
      )}

      <RouterGuard roles={accesRoles.reader} type="component">
        {renderMenuItem(
          <ListItemButton
            selected={selectedIndex === 2}
            onClick={() => {
              closeFinancialSubmenu();
              handleChangeIndex(2);
              handleDocumentActions();
              cleanLocalStorage("searchHistoryElectronicDocument");
              dispatch.menuDrawer.setCollapsed(true);
            }}
            className="itemDrawer"
            data-testid="item-menu-reportes"
          >
            <Link
              to={"/reportes"}
              aria-label="btn-reportes"
              data-testid="btn-menu-reportes"
            >
              <TrendingUp />
              {!collapsed && <>Reportes</>}
            </Link>
          </ListItemButton>,
          "Reportes",
        )}
      </RouterGuard>

      <RouterGuard roles={accesRoles.financialModule} type="component">
        <ClickAwayListener onClickAway={closeFinancialSubmenu}>
          <Box
            className={`menuItemWithSubmenu${financialSubmenuOpen ? " open" : ""}`}
          >
            {renderMenuItem(
              <ListItemButton
                selected={
                  collapsed && location.pathname.startsWith("/autorizaciones")
                }
                onClick={() => {
                  toggleFinancialSubmenu();
                }}
                className="itemDrawer"
                data-testid="item-menu-authorization"
              >
                <Box className="itemContent" component="div">
                  <CurrencyExchange />
                  {!collapsed && (
                    <>
                      <span>Módulo financiero</span>
                      {financialSubmenuOpen ? <ExpandLess /> : <ExpandMore />}
                    </>
                  )}
                </Box>
              </ListItemButton>,
              "Módulo financiero",
            )}
            <Collapse
              in={financialSubmenuOpen && !collapsed}
              timeout="auto"
              unmountOnExit
            >
              <Box className="submenuFinancial" data-testid="submenu-financial">
                {renderMenuItem(
                  <ListItemButton
                    selected={
                      selectedIndex === 30 ||
                      (location.pathname === "/autorizaciones" &&
                        selectedIndex !== 31)
                    }
                    className={`itemDrawer submenuItem${selectedIndex === 30 || (location.pathname === "/autorizaciones" && selectedIndex !== 31) ? " selected" : ""}`}
                    data-testid="submenu-item-candidate-payments"
                    onClick={() => {
                      dispatch.menuDrawer.setCollapsed(true);
                      handleChangeIndex(30);
                      handlePaymentsFetch();
                      closeFinancialSubmenu();
                    }}
                  >
                    <Link
                      to={"/autorizaciones"}
                      aria-label="btn-candidate-payments"
                      data-testid="btn-candidate-payments"
                    >
                      <Paid />
                      <span>Facturas candidatas para pagos</span>
                    </Link>
                  </ListItemButton>,
                  "Facturas candidatas para pagos"
                )}
                {renderMenuItem(
                  <ListItemButton
                    selected={selectedIndex === 31}
                    className={`itemDrawer submenuItem${selectedIndex === 31 ? " selected" : ""}`}
                    data-testid="submenu-item-exported-packages"
                    onClick={() => {
                      dispatch.menuDrawer.setCollapsed(true);
                      handleChangeIndex(31);
                      closeFinancialSubmenu();
                    }}
                  >
                    <Link
                      to={"/autorizaciones/paquetes-exportados"}
                      aria-label="btn-exported-packages"
                      data-testid="btn-exported-packages"
                    >
                      <PriceChange />
                      <span>Paquetes facturas exportadas para pago</span>
                    </Link>
                  </ListItemButton>,
                  "Paquetes facturas exportadas para pago"
                )}
                {renderMenuItem(
                  <ListItemButton
                    selected={selectedIndex === 32}
                    className={`itemDrawer submenuItem${selectedIndex === 32 ? " selected" : ""}`}
                    data-testid="submenu-item-seguimiento-cuentas"
                    onClick={() => {
                      dispatch.menuDrawer.setCollapsed(true);
                      handleChangeIndex(32);
                      setOpenSeguimientoCuentas(true);
                      closeFinancialSubmenu();
                    }}
                  >
                    <Box
                      component="div"
                      onClick={(e) => e.preventDefault()}
                      aria-label="btn-seguimiento-cuentas"
                      data-testid="btn-seguimiento-cuentas"
                    >
                      <AccountBalance />
                      <span>Seguimiento de cuentas por provisionar</span>
                    </Box>
                  </ListItemButton>,
                  "Seguimiento de cuentas por provisionar"
                )}
                {renderMenuItem(
                  <ListItemButton
                    selected={selectedIndex === 33}
                    className={`itemDrawer submenuItem${selectedIndex === 33 ? " selected" : ""}`}
                    data-testid="submenu-item-gestion-deducciones"
                    onClick={() => {
                      dispatch.menuDrawer.setCollapsed(true);
                      handleChangeIndex(33);
                      closeFinancialSubmenu();
                    }}
                  >
                    <Link
                      to={"/autorizaciones/gestion-deducciones"}
                      aria-label="btn-gestion-deducciones"
                      data-testid="btn-gestion-deducciones"
                    >
                      <Calculate />
                      <span>Gestión deducciones</span>
                    </Link>
                  </ListItemButton>,
                  "Gestión deducciones"
                )}
                {renderMenuItem(
                  <ListItemButton
                    selected={selectedIndex === 34}
                    className={`itemDrawer submenuItem${selectedIndex === 34 ? " selected" : ""}`}
                    data-testid="submenu-item-administrar-centro-costo"
                    onClick={() => {
                      dispatch.menuDrawer.setCollapsed(true);
                      handleChangeIndex(34);
                      closeFinancialSubmenu();
                    }}
                  >
                    <Link
                      to={"/autorizaciones/administrar-centro-costo"}
                      aria-label="btn-administrar-centro-costo"
                      data-testid="btn-administrar-centro-costo"
                    >
                      <ContentPasteSearch />
                      <span>Administrar centro de costo</span>
                    </Link>
                  </ListItemButton>,
                  "Administrar centro de costo"
                )}
              </Box>
            </Collapse>
          </Box>
        </ClickAwayListener>
      </RouterGuard>

      <RouterGuard roles={accesRoles.usersSSSA} type="component">
        {renderMenuItem(
          <ListItemButton
            selected={selectedIndex === 4}
            onClick={(event) => {
              closeFinancialSubmenu();
              handleChangeIndex(4);
              handleContractsFetch();
              dispatch.menuDrawer.setCollapsed(true);
            }}
            className="itemDrawer"
            data-testid="item-menu-contracts"
          >
            <Link
              to={"/contratos"}
              aria-label="btn-contracts"
              data-testid="btn-menu-contracts"
            >
              <Book />
              {!collapsed && <>Contratos</>}
            </Link>
          </ListItemButton>,
          "Contratos",
        )}
      </RouterGuard>

      <RouterGuard roles={accesRoles.adminUser} type="component">
        {renderMenuItem(
          <ListItemButton
            selected={selectedIndex === 5}
            onClick={(event) => {
              closeFinancialSubmenu();
              handleChangeIndex(5);
              dispatch.menuDrawer.setCollapsed(true);
            }}
            className="itemDrawer"
            data-testid="item-menu-users"
          >
            <Link
              to={"/gestion-usuarios-prestadores"}
              aria-label="btn-users"
              data-testid="btn-menu-users"
            >
              <LocalHospitalIcon />
              {!collapsed && <>Gestion de Usuarios Prestadores</>}
            </Link>
          </ListItemButton>,
          "Gestion de Usuarios Prestadores",
        )}
      </RouterGuard>
      <RouterGuard roles={accesRoles.adminUser} type="component">
        {renderMenuItem(
          <ListItemButton
            selected={selectedIndex === 6}
            onClick={(event) => {
              closeFinancialSubmenu();
              handleChangeIndex(6);
              dispatch.menuDrawer.setCollapsed(true);
            }}
            className="itemDrawer"
            data-testid="item-menu-users"
          >
            <Link
              to={"/gestion-usuarios"}
              aria-label="btn-users"
              data-testid="btn-menu-users"
            >
              <Group />
              {!collapsed && <>Gestion de Usuarios Internos</>}
            </Link>
          </ListItemButton>,
          "Gestion de Usuarios",
        )}
      </RouterGuard>
      <ModalSeguimientoCuentas
        open={openSeguimientoCuentas}
        onClose={() => setOpenSeguimientoCuentas(false)}
      />
    </Box>
  );
};
